import "./NoMatch.css"

const NoMatch = () => {
    return <div className="Container" >
        <p className="Content">Error 404: Not Found</p>
    </div>
}

export default NoMatch;